/* eslint-disable vue/no-unused-vars */
<template>
  <div class="customers">
    <a-card
      :headStyle="{ marginBottom: '0', paddingBottom: '0', minHeight: '40px' }"
      :bodyStyle="{ paddingTop: '3px' }"
      class="card"
    >
      <div v-if="showHeader" slot="title" :class="$style.listHeadTitle">
        <div :class="$style.searchWrapper">
          <a-input-search
            placeholder="Buscar..."
            enterButton
            @change="handleSearch"
          />
        </div>
      </div>
      <div v-if="showHeader" slot="extra" :class="$style.extraStyle">
        <a-dropdown
          placement="bottomCenter"
          style="margin-right:1rem"
          v-if="!orderBySelection.key"
        >
          <a class="ant-dropdown-link">
            <span :class="$style.orderByLabel">Orden: Nombre </span>
            <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleOrderByClick">
            <a-menu-item v-for="option in orderByOptions" :key="option.key">{{
              option.value
            }}</a-menu-item>
          </a-menu>
        </a-dropdown>

        <span
          v-else-if="orderBySelection.direction == 'asc'"
          :class="$style.orderByLabel"
        >
          Ordenar Por:
          <a-tag @click="handleOrderAscClick" color="green"
            >{{ orderBySelection.value }} <a-icon type="sort-ascending" />
          </a-tag>
        </span>
        <span v-else :class="$style.orderByLabel">
          Ordenar Por:
          <a-tag closable @click="handleOrderByClose" color="orange"
            >{{ orderBySelection.value }} <a-icon type="sort-descending" />
          </a-tag>
        </span>
      </div>
      <div v-if="displayEmptyMessage" style="margin-top:2rem">
        <h5 style="color:#555;">No se registran clientes.</h5>
      </div>
      <div
        :class="$style.demoInfiniteContainer"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="scrollDisabled"
        :infinite-scroll-distance="15"
        infinite-scroll-event-target="window"
      >
        <a-list :dataSource="listData" size="small">
          <a-list-item slot="renderItem" slot-scope="item" key="item.id">
            <a-list-item-meta>
              <!--
              <a-avatar
                slot="avatar"
                style="backgroundColor:#b7eb8f; borderColor:#52c41a"
                icon="user"
              />
              -->

              <div slot="avatar" :class="$style.avatarDiv">
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.green" icon="user" />
                </div>
                <span :class="[$style.idBox, $style.green]"
                  >#{{ item.id }}
                </span>
              </div>

              <h4 slot="title">
                <router-link :key="'view'" :to="`/customers/${item.id}`">
                  <strong
                    v-if="orderBySelection.value == 'Apellido'"
                    style="font-weight:normal"
                  >
                    {{ item.lastName }},
                    {{ item.firstName }}
                  </strong>
                  <span v-else style="font-weight:normal">
                    {{ item.firstName }}
                    {{ item.lastName }}
                  </span>
                </router-link>
                <span style="font-size:10px">&nbsp;</span>
              </h4>
              <div slot="description" :class="$style.grayText">
                <strong v-if="orderBySelection == 'DNI'">
                  DNI: {{ item.DNI }}
                  <br />
                </strong>
                <!--<span v-else> DNI: {{ item.DNI }} <br /></span>-->

                <span v-if="item.phone1">
                  <a
                    :href="'https://wa.me/' + item.phone1"
                    target="_blank"
                    :class="$style.grayText"
                    ><i class="icmn-whatsapp" style="font-size:11px" />&nbsp;{{
                      item.phone1
                    }}</a
                  >
                  |
                </span>
                <a
                  @click="handleEmailCopy(item.email)"
                  :class="[$style.grayText, $style.link]"
                >
                  <strong v-if="orderBySelection == 'Email'">
                    {{ item.email }}</strong
                  >
                  <span v-else>
                    {{ item.email }}
                  </span> </a
                ><!--
                |
                <span :class="$style.grayText">
                  Alta: {{ item.createdAt | moment("DD/MM/YYYY") }}
                </span>
                -->
              </div>
            </a-list-item-meta>

            <template slot="actions">
              <router-link :key="'edit'" :to="`/customers/${item.id}`"
                ><a-icon type="eye" /> Ver Detalle
              </router-link>
            </template>
          </a-list-item>

          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
            style="margin-top:2rem"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
        </a-list>
      </div>
    </a-card>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import store from "@/store";
import infiniteScroll from "@/services/vue-infinite-scroll";
import gateway from "@/services/gateway";
import utils from "@/services/utils";

export default {
  name: "customersList",
  directives: { infiniteScroll },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    subscriptionId: {
      default: null
    },
    customerId: {
      default: null
    }
  },
  data() {
    return {
      pagination: {
        position: "bottom"
      },
      loadingData: false,
      scrollDisabled: false,
      displayEmptyMessage: false,
      listData: [],
      orderBySelection: { key: null, value: null },
      orderByOptions: [
        { key: "id", value: "Id" },
        { key: "firstName", value: "Nombre" },
        { key: "lastName", value: "Apellido" },
        { key: "DNI", value: "DNI" },
        { key: "email", value: "Email" },
        { key: "createdAt", value: "Fecha de Alta" }
      ]
    };
  },
  methods: {
    ...mapActions({
      loadCustomers: "customers/load"
    }),
    async fetchList() {
      try {
        this.displayEmptyMessage = false;
        //console.log("params:", params);
        if (!this.loadingData) {
          this.loadingData = true;
          const result = await this.loadCustomers();
          if (store.state.customers.results.length > 0) {
            this.listData = this.listData.concat(store.state.customers.results);
          }

          //add results to existing results
          else this.displayEmptyMessage = true;

          this.loadingData = false;
        }
      } catch (error) {
        this.loadingData = false;
        if (error.status == 404) this.displayEmptyMessage = true;
        else {
          this.$notification["warning"]({
            message: error.code,
            description: error.statusCode
          });
        }
      }
    },
    async loadMore() {
      try {
        if (
          //todavia hay registros para bajar
          this.$store.state.customers.totalResults >
          this.$store.state.customers.page *
            this.$store.state.customers.pageSize
        ) {
          this.scrollDisabled = true;
          this.$nprogress.start();
          const result = await this.fetchList();
          this.scrollDisabled = false;
          this.$nprogress.done();
        }
        return;
      } catch (error) {
        this.scrollDisabled = false;
        this.$nprogress.done();
        this.$notification["failure"]({
          message: "Error",
          description: `Hubo un error al cargar el listado. Disabled: ${this.scrollDisabled}`
        });
      }
    },
    handleOrderByClick(event) {
      const orderByOption = this.orderByOptions.find(opt => {
        return opt.key == event.key;
      });
      this.orderBySelection = orderByOption;
      this.orderBySelection.direction = "asc";
      this.$store.commit("customers/SET_ORDER_BY", {
        orderBy: event.key,
        direction: "asc"
      }); //event.key);
      this.$store.commit("customers/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleOrderAscClick() {
      this.orderBySelection.direction = "desc";
      this.$store.commit("customers/SET_ORDER_BY", {
        orderBy: this.orderBySelection.key,
        direction: "desc"
      });
      this.$store.commit("customers/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleOrderByClose() {
      this.orderBySelection = { key: null, value: null };
      this.$store.commit("customers/SET_ORDER_BY", null);
      this.$store.commit("customers/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleSearch(keyword) {
      this.$store.commit("customers/SET_SEARCH", keyword.target.value);
      this.$store.commit("customers/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleEmailCopy(email) {
      utils.copyToClipboard(email);
      this.$notification["success"]({
        message: "Link copiado.",
        description:
          "Para pegarlo tipea ctrl + v en el teclado o elije la opción 'Pegar' con el botón derecho del mouse."
      });
    }
  },
  created() {
    //window.addEventListener("touchmove", this.loadMore);
  },
  mounted() {
    this.$store.commit("customers/SET_RESET");
    this.fetchList();
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<!-- Fue bastante dificil poder poner estilos en los componentes de antd que se apliquen unicamente para este componente, lo que sea que se aplicaba en uno se replicaba en todos los antd usados en otros componentes. Esto es porque a algunos elementos de antd se le aplican los id especiales que deberían llevar por tener el css scoped pero a otros no. A los que si se les aplica le pongo los estilos dentro de la definición scoped, a los que no, les pongo los estilos en la definición sin scoped con el prefijo ".transaction" que es una clase definida en el wrapper div.  -->
<style lang="css" scoped>
.ant-list-item-meta-title {
  margin-bottom: 0;
}
.ant-dropdown-menu-item {
  padding-top: 4px;
  padding-bottom: 4px;
}
.anticon-down {
  vertical-align: -0.24rem;
}
</style>

<style lang="css">
/*
.transaction-gray-text {
  font-size: 0.9rem;
  color: #aaa;
  font-weight: normal;
}
h4.transaction {
  font-size: 1.1rem;
  margin-bottom: 0 !important;
  color: #74708d;
}
.demo-loading-container {
  position: absolute;
  bottom: 50%;
  width: 100%;
  text-align: center;
}*/
.customers .ant-list-item-action {
  margin-top: 0;
  margin-bottom: 0;
}
.customers .ant-dropdown-link {
  text-transform: none;
  font-weight: normal;
}
.ant-card-head {
}
.ant-card-extra,
.ant-card-head-title {
}
/*
strong {
  color: black;
  font-weight: bold;
}
.search-wrapper {
  margin-right: 1rem;
}*/
@media (max-width: 767px) {
  /*
  .transactions .search-wrapper {
    margin-right: 0;
  }*/
  .customers .ant-card-head-wrapper {
    display: flex;
    align-items: flex-start;
    flex-flow: column;
  }
  .customers .ant-card-extra {
    margin-left: 3px;
    padding-top: 0;
  }
  .customers .ant-card-head-title {
    width: 100%;
  }
} /*
@media only screen and (min-width: 600px) {
  .br-sm {
    display: none;
  }
}*/
</style>
